export default {
  async initialize(actions) {
    const { token, userId } = await actions.getStoredAuthToken();
    await actions.loginWithToken({ token, userId });
  }
}
